<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.4516 14.9268H5.54839V34.439H34.4516V14.9268ZM34.4516 13.3659H5.54839V8.42276H34.4516V13.3659ZM36 36H4V6.86179H36V36Z"
      class="fill-current"
    />
    <path d="M8.12903 17.2683H13.2903V22.4715H8.12903V17.2683Z" class="fill-current" />
    <path d="M17.4194 17.2683H22.5806V22.4715H17.4194V17.2683Z" class="fill-current" />
    <path d="M26.7097 17.2683H31.871V22.4715H26.7097V17.2683Z" class="fill-current" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9677 4V10.7642H9.41935V4H10.9677ZM30.5806 4V10.7642H29.0323V4H30.5806Z"
      class="fill-current"
    />
  </svg>
</template>
